import axios from "axios";
import { toast } from "react-toastify";

const registerGlobalAxiosInterceptors = () => {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const data = error.response?.data;

      if (error.response?.status === 403 && data?.code === "impersonation_read_only") {
        toast.error("This action isn't available while viewing the dashboard as another user.");
        return Promise.reject(error);
      }

      const adminTokenBackup = localStorage.getItem("admin_token_backup");
      if (error.response?.status === 401 && adminTokenBackup) {
        const adminUserBackup = localStorage.getItem("admin_user_backup");
        localStorage.setItem("token", adminTokenBackup);
        if (adminUserBackup) localStorage.setItem("user_data", adminUserBackup);
        localStorage.removeItem("admin_token_backup");
        localStorage.removeItem("admin_user_backup");
        toast.error("Your view-as session expired. Returned to your admin account.");
        window.location.assign("/");
      }

      return Promise.reject(error);
    }
  );
};

export default registerGlobalAxiosInterceptors;
